// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"e2d77477","171":"08d4e6d0","371":"154603e7","374":"d29c2303","432":"33b3e139","435":"6884bd1f","507":"17b7fd65","521":"a11a4f83","743":"cd14ac62"}[chunkId] + ".chunk.js";
};